export default "__VITE_ASSET__CGPt5FKV__"